module.exports = __webpack_public_path__ + "media/images/brands/marque-l-oreal@2x-01d190bd93002ae346ec63e5a399cfe0.jpg";